import { PageMeta } from '../shared/PageMeta';

export function PendingApproval() {
  return (
    <div className="container mx-auto px-4 py-16 text-center">
      <PageMeta title="Pending Approval" description="Your account is awaiting admin approval" path="/marketplace/dashboard" />
      <div className="max-w-md mx-auto card p-8">
        <div className="w-16 h-16 rounded-full bg-amber-100 mx-auto mb-4 flex items-center justify-center">
          <svg className="w-8 h-8 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="text-2xl mb-2">Account Pending Approval</h2>
        <p className="text-spi-slate text-sm">
          Your account is being reviewed by our admin team. You'll receive an email once your account has been approved.
        </p>
      </div>
    </div>
  );
}
